/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RecentlyUpdatedCube { 
    frequencyCode?: string;
    lastDataChange?: string;
    lastStructureChange?: string;
    nameEn?: string;
    nameSk?: string;
    productCodeTitle?: string;
    publicId?: string;
    zonation?: Array<string>;
    zonationEn?: Array<string>;
    sectionId?: string;
    timePeriodFrom?: string;
    timePeriodTo?: string;
    updatedTimePeriod?: RecentlyUpdatedCube.UpdatedTimePeriodEnum;
}
export namespace RecentlyUpdatedCube {
    export type UpdatedTimePeriodEnum = 'TODAY' | 'YESTERDAY' | 'PAST_WEEK' | 'PAST_MONTH' | 'MISSING_TIMESTAMP';
    export const UpdatedTimePeriodEnum = {
        Today: 'TODAY' as UpdatedTimePeriodEnum,
        Yesterday: 'YESTERDAY' as UpdatedTimePeriodEnum,
        PastWeek: 'PAST_WEEK' as UpdatedTimePeriodEnum,
        PastMonth: 'PAST_MONTH' as UpdatedTimePeriodEnum,
        MissingTimestamp: 'MISSING_TIMESTAMP' as UpdatedTimePeriodEnum
    };
}


